import { createContext, useCallback, useState, type ReactNode } from 'react';
import { CANONICAL_THEMES, DEFAULT_THEME, THEME_STORAGE_KEY, isCanonicalTheme, type ThemeId } from './themeBootstrap';

export interface ThemeContextValue {
  theme: ThemeId;
  setTheme: (id: ThemeId) => void;
  themes: ThemeId[];
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setThemeState] = useState<ThemeId>(() => {
    const fromDom = typeof document !== 'undefined' ? document.documentElement.dataset.theme : undefined;
    return isCanonicalTheme(fromDom) ? fromDom : DEFAULT_THEME;
  });

  const setTheme = useCallback((id: ThemeId) => {
    if (!isCanonicalTheme(id)) return;
    if (typeof document !== 'undefined') document.documentElement.dataset.theme = id;
    try { localStorage.setItem(THEME_STORAGE_KEY, id); } catch { /* storage unavailable */ }
    setThemeState(id);
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: CANONICAL_THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}
